import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import Button from '@mlb/react-patterns/components/Button/button.tsx';

const { FILTER_MODAL_NAME } = modalConstants;

const FilterButton = (props) => {

    const {
        onClick,
        labelKey,
    } = props;

    const { modalToggle } = useModalStore();
    const dictionary = useDictionary();

    const onClickHandler = useCallback(() => {

        onClick();
        modalToggle(FILTER_MODAL_NAME);

    }, [
        onClick,
        modalToggle,
    ]);

    return (
        <Button
            handlers={{
                onClick: onClickHandler,
            }}
            label={dictionary[labelKey] || 'Filter'}
            {...props}
        />
    );

};

FilterButton.propTypes = {
    onClick: PropTypes.func,
    labelKey: PropTypes.string,
};

FilterButton.defaultProps = {
    onClick: _noop,
    labelKey: 'filter',
};

export default FilterButton;
